export default __webpack_public_path__ + "static/3-da87723e3b4ed46782d1841abea53d0d.webp";